module.exports = __webpack_public_path__ + "static/media/corcoran-logo.925c60f1.png";